import { A4uCropLightning as IconComponent } from '@adobe/react-spectrum-workflow/dist/CropLightning.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function CropLightning(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}